import React, { useState } from 'react';
import { IoMdArrowDropright } from "react-icons/io";
import { useNavigate } from 'react-router-dom';

function Premium() {
  const [premiumMail, setPremiumMail] = useState('');
  const [successMessage, setSuccessMessage] = useState(''); 
  const navigate = useNavigate(); 

  const handleChange = (e) => {
    e.preventDefault();
    setPremiumMail(e.target.value);
  };

  const handlePress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleClick();
    }
  }

  const handleClick = () => {
    setSuccessMessage('Successfully Registered!'); 
    setPremiumMail('');
  };

  return (
    <div 
      className="relative flex items-center justify-center min-h-screen text-center"
      style={{ 
        backgroundImage: 'url(/bg12.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <button 
        onClick={() => navigate('/app')} 
        className="absolute top-4 left-4 text-white"
      > 
        <img
          src="https://img.icons8.com/?size=100&id=40217&format=png&color=FFFFFF"
          alt="back"
          className="w-6 h-6"
        />
      </button>
      
      <div className="animate-drop-once">
        <h1 className="text-5xl md:text-6xl font-bold mb-4 hover:scale-110 transition-transform duration-300 gem">
          GemX Premium!!
        </h1>
        <p className="text-2xl md:text-3xl mb-8 hover:scale-110 transition-transform duration-300 text-white">
          Coming soon..
        </p>
        <div className="flex justify-center mb-4">
          <input
            onChange={handleChange}
            value={premiumMail}
            onKeyDown={handlePress}
            type="email"
            placeholder="Enter Your Email Address"
            className="p-2 w-64 md:w-80 border-none text-black rounded-l dark:bg-black focus:outline-primary dark:focus-within:bg-black"
          />
          <button onClick={handleClick} className="p-2 bg-yellow-400 text-black rounded-r">
            <IoMdArrowDropright className="text-3xl hover:scale-110 transition-transform duration-300" />
          </button>
        </div>
        <p className="text-sm md:text-base hover:scale-110 transition-transform duration-300 text-white">
          We will notify you on your mail, stay tuned for updates!
        </p>
        {successMessage && ( 
          <p className="mt-4 text-lg text-green-400">{successMessage}</p>
        )}
      </div>
    </div>
  );
}

export default Premium;
